// extracted by mini-css-extract-plugin
export default {"table":"discount-report_table__JSqzg"};